import React, {useRef, useState} from 'react';
import {Button} from 'reactstrap';

const SignatureModule = ({config}) => {
	const canvasRef = useRef(null);
	const [drawing, setDrawing] = useState(false);

	const getPosition = (event) => {
		const canvas = canvasRef.current;
		const rect = canvas.getBoundingClientRect();
		const source = event.touches ? event.touches[0] : event;
		return {
			x: source.clientX - rect.left,
			y: source.clientY - rect.top
		};
	};

	const start = (event) => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		const position = getPosition(event);
		ctx.beginPath();
		ctx.moveTo(position.x, position.y);
		setDrawing(true);
	};

	const draw = (event) => {
		if (!drawing) return;
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		const position = getPosition(event);
		ctx.lineTo(position.x, position.y);
		ctx.strokeStyle = '#222';
		ctx.lineWidth = 2;
		ctx.lineCap = 'round';
		ctx.stroke();
	};

	const stop = () => {
		setDrawing(false);
	};

	const clear = () => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		ctx.clearRect(0, 0, canvas.width, canvas.height);
	};

	return (
		<div style={{padding: '16px', border: '1px solid #dcdcdc', borderRadius: '6px'}}>
			<h5 style={{marginTop: 0}}>{config.title || 'Signature'}</h5>
			<p>{config.description || 'Please sign in the area below.'}</p>
			<canvas
				ref={canvasRef}
				width={520}
				height={180}
				style={{width: '100%', maxWidth: '520px', border: '1px solid #ccc', background: '#fff'}}
				onMouseDown={start}
				onMouseMove={draw}
				onMouseUp={stop}
				onMouseLeave={stop}
				onTouchStart={start}
				onTouchMove={draw}
				onTouchEnd={stop}
			/>
			<div style={{marginTop: '10px'}}>
				<Button size="sm" className="secondary-button" onClick={clear}>Clear Signature</Button>
			</div>
		</div>
	);
};

export default SignatureModule;
